import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import * as firebase from 'firebase'; 

Vue.config.productionTip = false;

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_KEY,
  authDomain: "crew-saver.firebaseapp.com",
  databaseURL: "https://crew-saver.firebaseio.com",
  projectId: "crew-saver",
  storageBucket: "crew-saver.appspot.com",
  messagingSenderId: "875812315285",
  appId: "1:875812315285:web:02103db91fb678b433bb9c",
  measurementId: "G-KD747QTJMX"
};

firebase.initializeApp(firebaseConfig);

new Vue({
  router,
  vuetify,
  render: h => h(App)
}).$mount("#app");
